import { AppLegal, type IAppLegal, type ILegalStores } from "./AppLegal";
import type { LegalViewModelModel } from "../../OpenApi/api";
import type { IAppStoresFactory } from "../shared-components/AppStoresFactory";
import type { IInitialResourcesLoader } from "../resources/InitialResourcesLoader";

export interface IAppLegalFactory {
    create(viewModel: LegalViewModelModel, initialResourcesLoader: IInitialResourcesLoader): Promise<IAppLegal>;
}

export class AppLegalFactory implements IAppLegalFactory {
    constructor(private readonly appStoresFactory: IAppStoresFactory) {}

    public async create(viewModel: LegalViewModelModel, initialResourcesLoader: IInitialResourcesLoader): Promise<IAppLegal> {
        const { appStoresFactory } = this;
        /* stores */
        const appStores = await appStoresFactory.create(viewModel.layout, initialResourcesLoader);

        const legalStores: ILegalStores = {
            ...appStores,
        };

        return new AppLegal(legalStores);
    }
}
